import {
  Directive, Input,
  ViewContainerRef, Inject, Self, ComponentFactoryResolver, ElementRef, AfterViewInit, ViewChild
} from '@angular/core';
import {MoreNodeComponent} from './po-treeview/more-node/more-node.component';
import {PONodeComponent} from './po-treeview/abstract-classes/po-node/ponode.component';
import {ArrangementLevelComponent} from "./po-treeview/abstract-classes/arrangement-level/arrangement-level.component";
import {ClusterNodeComponent} from "./po-treeview/cluster-node/cluster-node.component";
import {PoTreeviewComponent} from "./po-treeview/po-treeview.component";

@Directive({
  selector: '[appExpandAll]',
})
export class ExpandAllDirective {

  viewChanged = false;
  parentComponent: any;
  hostComponentInstance: any;

  constructor(public el: ElementRef, private viewContainer: ViewContainerRef) {
  }

  @Input() set hostComponent(component: any) {
    this.hostComponentInstance = component;
  }

  @Input() set appExpandAll(expand: boolean) {

    if (expand && this.viewChanged)
    {
      return;
    } // already expanded

    const parentComponent = this.hostComponentInstance;
    if (expand) {
      if (parentComponent instanceof PONodeComponent) {
        parentComponent.expand();
      }
      this.expandChildren(parentComponent);
      this.viewChanged = true;
    } else if (!expand && this.viewChanged) {
      parentComponent.children.forEach((child) => {
        this.collapse(child);
      });
      this.viewChanged = false;
    }
  }

  private expandChildren(component: any): void {

    if (!component || !Array.isArray(component.children)) {
      console.warn('expandChildren aborted — no valid children array');
      return;
    }
    // First pass: trigger lazy loading
    component.children.forEach((child) => {
      if (child && typeof this.exposeArrangementsUnderModeComponent === 'function') {
        this.exposeArrangementsUnderModeComponent(child);
      }
    });

    // Second pass: defer expansion to allow children to initialize
    component.children.forEach((child) => {
      if (child) {
        this.expand(child);
      }
    });
  }

  private exposeArrangementsUnderModeComponent(child: any): void {
    if (child instanceof MoreNodeComponent) {
      console.log('exposeArrangementsUnderModeComponent MoreNodeComponent');
      child.onClick();
    }
  }

  private expand(component: any): void {
    if (component && component.expandable && typeof component.expand === 'function') {
      component.expand();
      this.expandChildren(component);
    }
  }

  private collapse(component) {
    component.collapse();
    component.children.forEach((child) => {
      this.collapse(child);
    });
  }

}
